import { useState } from 'react';
import { ImagesList } from './parts/ImagesList';
import { UploadMore } from './parts/UploadMore';
import CloseButton from './imgs/close.svg';
import './ImagesUploader.css';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  MouseSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  rectSortingStrategy,
} from '@dnd-kit/sortable';

export default function ImagesUploader({ files = [], onUploadMore, onClose, onRemoveImage }) {
  const [images, setImages] = useState([...files]);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    }),
    useSensor(KeyboardSensor, {
      activationConstraint: {
        distance: 5,
      },
      coordinateGetter: sortableKeyboardCoordinates,
    }),
    useSensor(MouseSensor, {
      activationConstraint: {
        distance: 5,
      },
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    const hasItems = Boolean(active?.id) && Boolean(over?.id);
    if (hasItems && active.id !== over.id) {
      setImages((items) => {
        const oldIndex = items.indexOf(active.id);
        const newIndex = items.indexOf(over.id);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  };

  const handleCloseModal = async () => {
    await onClose(images);
  };

  const handleUploadMore = async () => {
    await onUploadMore(images);
  };

  const handleRemoveImage = async (image) => {
    setImages((prev) => prev.filter((i) => i !== image));

    await onRemoveImage(images);
  };

  return (
    <div>
      <div
        onClick={handleCloseModal}
        style={{
          cursor: 'pointer',
          position: 'absolute',
          top: '-12px',
          right: '-12px',
        }}>
        <img src={CloseButton} alt="close" />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '16px',
        }}>
        <div className="upload_file_title">Images</div>
        <UploadMore onUploadMore={handleUploadMore} />
      </div>
      <div className="image_drop_zone">
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
          <SortableContext items={images} strategy={rectSortingStrategy}>
            <ImagesList images={images} onRemoveImage={handleRemoveImage} />
          </SortableContext>
        </DndContext>
      </div>
    </div>
  );
}
